const formatarPreco = (valor: number | string): string => {
    const numero = Number(valor);
    if (isNaN(numero)) return "Valor inválido";
  
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(numero);
  };
  
  export default formatarPreco;
  